<template>
  <div class="padding-10">
    <div class="d-flex">
      <v-spacer></v-spacer>
      <v-btn class="primary" depressed tile @click="copyAll()">Copy All</v-btn>
    </div>
    <v-card :elevation="$root.ele" class="mt-5">
      <v-data-table
        :headers="headers"
        class="templates-table"
        :loading="loading"
        :items="list"
        :footer-props="{
          'items-per-page-options': [10, 20, 50, -1],
        }"
        :items-per-page="50"
      >
      </v-data-table>
    </v-card>
  </div>
</template>
    
    <script>
import customerModal from "../assets/js/customer.modal";
import { customers } from "../assets/js/firebase";
export default {
  data() {
    return {
      loading: true,
      list: [],
    };
  },
  computed: {
    headers() {
      let headers = [
        { text: "Customer Name", value: "name" },
        { text: "Customer Email", value: "email" },
      ];
      let list = [];
      for (let item of headers) {
        let { text, value } = item;
        let doc = {
          text,
          value,
          class: "text-capitalize",
          align: "start",
          sortable: true,
          divider: true,
        };
        if (value === "action") doc.divider = false;
        list.push(doc);
      }
      return list;
    },
    users() {
      return this.$store.getters.users;
    },
  },
  methods: {
    copyAll() {
      let text = this.list
        .map((i) => i.email)
        .toString()
        .split(",")
        .join("\n");
      navigator.clipboard.writeText(text);
      this.$alert.show("Copied");
      // this.$snackbar.show("Code copied!");
    },
    async fetchCustomers() {
      const vm = this;
      try {
        let query = customers.where(`fields.${customerModal.EMAIL}`, "!=", "");
        let list = (await query.get()).docs.map((item) => ({
          id: item.id,
          ...item.data(),
          email: item.data().fields[customerModal.EMAIL],
        }));
        vm.list = [];
        list.forEach((i) => {
          let item = vm.list.find((item) => item.email == i.email);
          if (!item) vm.list.push(i);
        });
        vm.loading = false;
      } catch (error) {
        vm.loading = false;
        vm.$alert.show(error.message);
      }
    },
  },
  mounted() {
    this.fetchCustomers();
  },
};
</script>
    
    <style lang="scss"></style>
    